import React from 'react'
import './ButtonDashb.css'
const ButtonDahbaord = ({editButton,background,padding,height,width,textButton,handleclick}) => {
    const buttonClass = background === 'purple' ? 'btn-purple' : 'btn-transparent';
    const style = {
        height: height,
        width: width,
        padding:padding,
        background:editButton,
        borderColor:editButton
      };
  return (
    <div onClick={handleclick}   className={`btn-button-dashboard ${buttonClass}`} style={style}>
        <p className='btn-paragrph'>{textButton}</p>
    </div>
  )
}

export default ButtonDahbaord